import React from "react";
import "../css/CorePhilosophy.css";

const CorePhilosophy = () => {
  const philosophyImg =
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80";

  return (
    <section className="philosophy-section">
      <div className="philosophy-container">
        {}
        <div className="philosophy-image-box">
          <div className="philosophy-dashed-frame"></div>
          <img
            src={philosophyImg}
            alt="Core Philosophy"
            className="philosophy-img"
          />
        </div>

        {}
        <div className="philosophy-text-box">
          <h2 className="philosophy-heading">Our Core Philosophy</h2>
          <p className="philosophy-motto">
            Our Motto: To Provide Quality Education & Personal Excellence
          </p>

          <ul className="philosophy-list">
            <li>
              <strong>To provide</strong> quality education according to
              Nepalese syllabus.
            </li>
            <li>
              <strong>To provide</strong> and support environment.
            </li>
            <li>
              <strong>To provide</strong> committed, motivated, talented and
              knowledgeable teaching staff.
            </li>
            <li>
              <strong>To provide</strong> modern facilities such as Computer
              lab, Science lab, Library and adequate playing fields.
            </li>
            <li>
              <strong>Honesty,</strong> Integrity and Ethical Practices
            </li>
            <li>
              <strong>Attitude</strong> before Knowledge
            </li>
            <li>
              <strong>Teamwork</strong>
            </li>
            <li>
              <strong>Mentor,</strong> Coach and Make a Difference
            </li>
            <li>
              <strong>Ambience</strong> for Learning
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CorePhilosophy;
